import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './appRoutes';
import { UserProvider } from './utils/userProvider';

function App() {
  return (
    <>
      <Router>
        <UserProvider>
          <AppRoutes />
        </UserProvider>
      </Router>
    </>
  );
}

export default App;
